import FillSpin from 'components/fill-spin';
import { useUserWhoAmIRequest } from 'hooks/useUser';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
import { css } from '@emotion/css';
import THEME from 'styles/colors';
import { styleSpin } from './index.style';

const ProjectProfileFormPage = lazy(() => import('pages/project-profile/form'));
const ProjectProfilePage = lazy(() => import('pages/project-profile'));

export default function AdminContainer() {
  const location = useLocation();
  const history = useHistory();
  const { loading } = useUserWhoAmIRequest({
    onError(err) {
      if (err?.message?.indexOf?.('401') > -1) {
        history.push(`/login?redirect-url=${encodeURIComponent(window.location.pathname + window.location.search)}`);
      }
    },
  });

  if (loading) {
    return (
      <div className={styleWrapperContainer}>
        <div className={styleContent}>
          <FillSpin spinning className={styleSpin} />
        </div>
      </div>
    );
  }

  return (
    <div className={styleWrapperContainerAdmin}>
      <div className={styleContent}>
        <Suspense fallback={<FillSpin spinning className={styleSpin} />}>
          <Switch location={location}>
            <Route path="/admin/project-profile/:questionnaireId" exact component={ProjectProfileFormPage} />
            <Route path="/admin" exact component={ProjectProfilePage} />
            <Redirect to="/admin" />
          </Switch>
        </Suspense>
      </div>
    </div>
  );
}

export const styleWrapperContainer = css`
  height: 100vh;
  overflow: hidden;
  display: flex;
`;

export const styleWrapperContainerAdmin = css`
  height: calc(100vh - 64px);
  overflow: hidden;
  display: flex;
`;

export const styleContent = css`
  flex: 1;
  overflow: auto;
  background: ${THEME.fifth};
`;
